// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__vmCeD","size_default":"Container_size_default__SbrEy","size_full":"Container_size_full__1S7Nn"};